module.exports = __webpack_public_path__ + "static/media/banner-right.de221032.svg";